export default __webpack_public_path__ + "static/media/carpet.f871a002.png";